import axios from 'axios';
import logger from '../LocalServer/logger';

export const MSCLogin = async () => {
  logger(2, 'Start To Login');
  return new Promise(async (resolve, reject) => {
    await axios
      .post(`${localStorage.getItem('MSC_API')}/iam/v1/sso/login`, {
        login: localStorage.getItem('MSC_USER'),
        password: localStorage.getItem('MSC_PASS'),
      })
      .then(function (response) {
        logger(2, 'Successfully Login');
        localStorage.setItem('msc-token', response?.data?.responsePayload?.access_token);
        localStorage.setItem('msc-refresh', response?.data?.responsePayload?.refresh_token);
        resolve(true);
      })
      .catch(function (error) {
        logger(1, 'Login Failed = ' + JSON.stringify(error));
        // alert('Login Failed, please check the login information');
        resolve(false);
      });
  });
};
